// extracted by mini-css-extract-plugin
export var editButton = "footer-module--edit-button--df965";
export var footer = "footer-module--footer--50412";
export var footerBottom = "footer-module--footer-bottom--08fc2";
export var footerContent = "footer-module--footer-content--8d63c";
export var footerLinks = "footer-module--footer-links--839bc";
export var footerRss = "footer-module--footer-rss--cdad0";
export var footerSocial = "footer-module--footer-social--ded1d";
export var goToHead = "footer-module--go-to-head--1606f";